// import React, { useState } from "react";
// import QuestionsBox from "../QuestionInstructions/QuestionsBox";
// import marker from "../../../src/assests/images/marker_black.svg";
// import { useTaskContext } from "../store/AlltasksContext";
// import Notes from "../QuestionInstructions/Notes";
// import trash from "../../../src/assests/images/trash.svg";
// import plus from "../../../src/assests/images/plus_red.svg";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// // import {  } from "../QuestionInstructions/VisibilityProvider";
// import ImageUploadTask from "../FileuploadWithPreview/ImageUploadTask";
// import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
// interface EducationQuestionsProps {
//   lang: {
//     imgageGifVideo: string;
//     uploadImage: string;
//     pageLabel: string;
//     uploadText: string;
//     uploadSize: string;
//     addMore: string;
//     instruction: string;
//     addInstruction: string;
//     option: string;
//     questionPoint: string;
//     writeHintCorrectOption: string,
//     addOptions: string,
//     selectCorrectOptionHint: string,
//     selecttype: string,
//     //Dotcode drop down
//     educationalTaskDrop: string,
//     targetTaskDrop: string,
//     feedbackTaskDrop: string,
//     dotcodeScanningDrop: string,
//     imageCaptureDrop: string,
//     selectoption: string,

//   };
//   Tabname?: string;
// }
// const EducationalQuestions: React.FC<EducationQuestionsProps> = ({ lang }) => {
//   const {
//     Tabname, setTabname,
//     showNoTask,
//     educationalData,
//     seteducationalData,
//     showImageUploadBanner,
//   } = useTaskContext();
//   console.log(Tabname, "Tabname")
//   const [selectedOption, setSelectedOption] = useState<string>("");
//   const handleNameChange = (name: string) => {
//     console.log(`Name changed to ${name}`);
//   };



//   const options = [
//     { label: lang.educationalTaskDrop, value: "educational" },
//     { label: lang.targetTaskDrop, value: "target" },
//     { label: lang.feedbackTaskDrop, value: "feedback" },
//     { label: lang.dotcodeScanningDrop, value: "dotcode" },
//     { label: lang.imageCaptureDrop, value: "imagecapture" },
//   ];


//   const handleDropdownChange = (event: SelectChangeEvent<string>) => {
//     setSelectedOption(event.target.value);
//   }
//   const handleDeleteSection = (id: number) => {
//     seteducationalData((prevData) =>
//       prevData.filter((section) => section.id !== id)
//     );
//   };

//   const gridData = [
//     {
//       id: 1,
//       title: "Notes",
//       placeholderPrefix: "Write a note if required",
//       notes: [{ id: 1, value: "" }],
//     },
//   ];

//   return (
//     <div>
//       {(Tabname === "Dotcode Scanning Task" || Tabname === "डॉटकोड स्कैनिंग कार्य") && (
//         <Box sx={{ marginTop: "15px", marginLeft: "0px", width: "300px", marginBottom: "30px" }}>
//           {/* Separate label above the dropdown */}
//           <Box sx={{ marginBottom: "4px" }}>
//             <Typography sx={{ fontSize: "16px", fontWeight: 500, color: "#282829", marginBottom: "10px" }}>
//               {lang.selecttype}
//             </Typography>
//           </Box>

//           {/* Dropdown with arrow */}
//           <FormControl fullWidth variant="outlined">
//             <Select
//               value={selectedOption}
//               onChange={handleDropdownChange}
//               displayEmpty
//               IconComponent={(props) => <KeyboardArrowDownIcon {...props} />} // Arrow icon
//               sx={{
//                 borderRadius: "4px",
//                 borderColor: "#ccc",
//                 background: "#fff",
//                 height: "56px",
//                 '& .MuiSelect-select': { padding: "10px" },
//               }}
//             >
//               <MenuItem value="" disabled>
//                 {lang.selectoption}
//               </MenuItem>
//               {options.map((option) => (
//                 <MenuItem key={option.value} value={option.value}>
//                   {option.label}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Box>
//       )}

//       <ImageUploadTask
//         sectionTitle={lang.imgageGifVideo}
//         placeholder="Your Name"
//         pageLabel={lang.pageLabel}
//         bannerProps={{
//           // title: "Upload Image",
//           // uploadText: "Drag & Drop your Image/Gif here or Choose file",
//           // uploadSize: "PNG, JPG, GIF, SVG (Max 5 MB)nnnnnnnnnnnnnnn",
//           title: lang.uploadImage,
//           uploadText: lang.uploadText,
//           uploadSize: lang.uploadSize,
//           imageUrls: "",
//           maintitle: "",
//           setuploadedImage: (image) => console.log(`Uploadedssss image: ${image}`),
//         }}
//         lang={lang}
//         instructions={[{ id: 1, value: "", image: "", smallimage: "", bigimage: "" }]}
//         markerImage={marker}
//         onNameChange={handleNameChange}
//         trashIcon={trash} iconImage={""} setIconImage={function (value: React.SetStateAction<string>): void {
//           throw new Error("Function not implemented.");
//         }} />
//       <QuestionsBox
//         seteducationalData={seteducationalData}
//         educationalData={educationalData}
//         sectionsData={educationalData}
//         setSectionsData={seteducationalData}
//         onDeleteSection={handleDeleteSection}
//         combinedqtnclass={"eduqtnbox"}

//         lang={lang} />
//       {showNoTask && (
//         <Notes gridData={gridData} trashIcon={trash} plusIcon={plus} />
//       )}


//       {showImageUploadBanner && (
//         <ImageUploadTask
//           sectionTitle={lang.imgageGifVideo}
//           placeholder="Your Name"
//           pageLabel={lang.pageLabel}
//           bannerProps={{
//             title: lang.uploadImage,
//             uploadText: lang.uploadText,
//             uploadSize: lang.uploadSize,
//             imageUrls: "",
//             maintitle: "",
//             setuploadedImage: (image) => console.log(`Uploaded image: ${image}`),
//           }}
//           lang={lang}
//           instructions={[{ id: 1, value: "", image: "", smallimage: "", bigimage: "" }]}
//           markerImage={marker}
//           onNameChange={handleNameChange}
//           trashIcon={trash} iconImage={""} setIconImage={function (value: React.SetStateAction<string>): void {
//             throw new Error("Function not implemented.");
//           }} />
//       )}

//     </div>
//   );
// };

// export default EducationalQuestions;
import React, { useState } from "react";
import QuestionsBox from "../QuestionInstructions/QuestionsBox";
import marker from "../../../src/assests/images/marker_black.svg";
import { useTaskContext } from "../store/AlltasksContext";
import Notes from "../QuestionInstructions/Notes";
import trash from "../../../src/assests/images/trash.svg";
import plus from "../../../src/assests/images/plus_red.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import {  } from "../QuestionInstructions/VisibilityProvider";
import ImageUploadTask from "../FileuploadWithPreview/ImageUploadTask";
import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
interface EducationQuestionsProps {
  lang: {
    imgageGifVideo: string;
    uploadImage: string;
    pageLabel: string;
    uploadText: string;
    uploadSize: string;
    addMore: string;
    instruction: string;
    addInstruction: string;
    option: string;
    questionPoint: string;
    writeHintCorrectOption: string,
    addOptions: string,
    selectCorrectOptionHint: string,
    selecttype: string,
    //Dotcode drop down
    educationalTaskDrop: string,
    targetTaskDrop: string,
    feedbackTaskDrop: string,
    dotcodeScanningDrop: string,
    imageCaptureDrop: string,
    selectoption: string,

  };
  Tabname?: string;
}
const EducationalQuestions: React.FC<EducationQuestionsProps> = ({ lang }) => {
  const {
    Tabname, setTabname,
    showNoTask,
    educationalData,
    seteducationalData,
    showImageUploadBanner,
    selectedOption1,
    setSelectedOption1
  } = useTaskContext();
  console.log(Tabname, "Tabname")
  // const [selectedOption, setSelectedOption] = useState<string>("");
  const handleNameChange = (name: string) => {
    console.log(`Name changed to ${name}`);
  };


console.log(selectedOption1, "selectedOption1ssss")
  const options = [
    { label: lang.educationalTaskDrop, value: "Availability" },
    { label: lang.targetTaskDrop, value: "Ranging" },
    { label: lang.feedbackTaskDrop, value: "Stock weight" },
    { label: lang.dotcodeScanningDrop, value: "Micro Targeting" },
    // { label: lang.imageCaptureDrop, value: "Image Capture" },
  ];


  const handleDropdownChange = (event: SelectChangeEvent<string>) => {
    console.log(event.target.value, "event.target.valueevent.target.value")
    setSelectedOption1(event.target.value);
  }
  const handleDeleteSection = (id: number) => {
    seteducationalData((prevData) =>
      prevData.filter((section) => section.id !== id)
    );
  };

  const gridData = [
    {
      id: 1,
      title: "Notes",
      placeholderPrefix: "Write a note if required",
      notes: [{ id: 1, value: "" }],
    },
  ];
console.log(selectedOption1, "selectedOption1")
  return (
    <div>
      {(Tabname === "Dotcode Scanning Task" || Tabname === "डॉटकोड स्कैनिंग कार्य") && (
        <Box sx={{ marginTop: "15px", marginLeft: "0px", width: "300px", marginBottom: "30px" }}>
          {/* Separate label above the dropdown */}
          <Box sx={{ marginBottom: "4px" }}>
            <Typography sx={{ fontSize: "16px", fontWeight: 500, color: "#282829", marginBottom: "10px" }}>
              {lang.selecttype}
            </Typography>
          </Box>

          {/* Dropdown with arrow */}
          <FormControl fullWidth variant="outlined">
            <Select
              value={selectedOption1}
              onChange={handleDropdownChange}
              displayEmpty
              IconComponent={(props) => <KeyboardArrowDownIcon {...props} />} // Arrow icon
              sx={{
                borderRadius: "4px",
                borderColor: "#ccc",
                background: "#fff",
                height: "56px",
                '& .MuiSelect-select': { padding: "10px" },
              }}
            >
              <MenuItem value="" disabled>
                {lang.selectoption}
              </MenuItem>
              {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      )}

      <ImageUploadTask
        sectionTitle={lang.imgageGifVideo}
        placeholder="Your Name"
        pageLabel={lang.pageLabel}
        bannerProps={{
          // title: "Upload Image",
          // uploadText: "Drag & Drop your Image/Gif here or Choose file",
          // uploadSize: "PNG, JPG, GIF, SVG (Max 5 MB)nnnnnnnnnnnnnnn",
          title: lang.uploadImage,
          uploadText: lang.uploadText,
          uploadSize: lang.uploadSize,
          imageUrls: "",
          maintitle: "",
          setuploadedImage: (image) => console.log(`Uploadedssss image: ${image}`),
        }}
        lang={lang}
        instructions={[{ id: 1, value: "", image: "", smallimage: "", bigimage: "" }]}
        markerImage={marker}
        onNameChange={handleNameChange}
        trashIcon={trash} iconImage={""} setIconImage={function (value: React.SetStateAction<string>): void {
          throw new Error("Function not implemented.");
        }} />
      <QuestionsBox
        seteducationalData={seteducationalData}
        educationalData={educationalData}
        sectionsData={educationalData}
        setSectionsData={seteducationalData}
        onDeleteSection={handleDeleteSection}
        combinedqtnclass={"eduqtnbox"}

        lang={lang} />
      {showNoTask && (
        <Notes gridData={gridData} trashIcon={trash} plusIcon={plus} />
      )}


      {showImageUploadBanner && (
        <ImageUploadTask
          sectionTitle={lang.imgageGifVideo}
          placeholder="Your Name"
          pageLabel={lang.pageLabel}
          bannerProps={{
            title: lang.uploadImage,
            uploadText: lang.uploadText,
            uploadSize: lang.uploadSize,
            imageUrls: "",
            maintitle: "",
            setuploadedImage: (image) => console.log(`Uploaded image: ${image}`),
          }}
          lang={lang}
          instructions={[{ id: 1, value: "", image: "", smallimage: "", bigimage: "" }]}
          markerImage={marker}
          onNameChange={handleNameChange}
          trashIcon={trash} iconImage={""} setIconImage={function (value: React.SetStateAction<string>): void {
            throw new Error("Function not implemented.");
          }} />
      )}

    </div>
  );
};

export default EducationalQuestions;